import { Alert, Box, Button, Container, Divider, LinearProgress, Stack } from '@mui/material'
import { DataGrid, GridCellParams, GridColDef, GridToolbar, GridValueFormatterParams, GridValueGetterParams } from '@mui/x-data-grid';
import { t } from 'i18next'
import React from 'react'
import { useHorseShoeing } from '../../hooks/useHorseShoeing';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../store';
import { TUser } from '../../shared/types/user.type';
import DataGridActions from '../../components/global/DataGridActions';
import { setShoeingItemToEdit, setShoeingModal } from '../../store/reducers/modal.reducer';
import { isEmpty, toNumber } from 'lodash';
import I18nDataGrid from '../../components/global/I18nDataGrid';
import { Add } from '@mui/icons-material';

function Shoeing() {
  const dispatch = useDispatch()
  const auth = useSelector<RootState>(state => state.user.user) as TUser | null
  const isUserLoading = useSelector<RootState>(state => state.user.isUserLoading) as boolean
  const { shoeings, isLoading, deleteShoeing, isDeleting } = useHorseShoeing(!isUserLoading, auth?.id)

  const columns: GridColDef[] = [
    { field: 'id', headerName: 'ID' },
    {
      field: 'name',
      headerName: t('editTrainingForm:horseShoeing:label'),
      flex: 1,
      valueFormatter: (param: GridValueFormatterParams) => {
        return param.value ?? '-'
      }
    },
    {
      field: 'brand',
      headerName: t('horseShoeing:brand'),
      flex: 1,
      valueFormatter: (param: GridValueFormatterParams) => {
        return param.value ?? '-'
      }
    },
    {
      field: 'material',
      headerName: t('horseShoeing:material'),
      flex: 1,
      valueFormatter: (param: GridValueFormatterParams) => {
        return param.value ?? '-'
      }
    },
    {
      field: 'weight',
      headerName: t('parameters:weight') + '(G)',
      // type: 'number',
      align: 'left',
      flex: 1,
      valueFormatter: (param: GridValueFormatterParams) => {
        return (param?.value ?? 0) + ' g'
      },
    },
    {
      headerName: t('settings:actions'),
      field: 'actions',
      flex: 1,
      renderCell: (params: GridCellParams) =>
        <DataGridActions
          deleteTitle='horseShoeing:deleteHs'
          deleteSubtitle='horseShoeing:deleteHsMessage'
          onEdit={() => {
            dispatch(setShoeingItemToEdit(params.row))
            dispatch(setShoeingModal(true))
          }}
          isDeleting={isDeleting}
          onDelete={() => { deleteShoeing(toNumber(params.id)) }}
        ></DataGridActions>
    }
  ];



  return (
    <Stack direction={'column'} spacing={2}>
      {
        !isEmpty(shoeings) && <Box display={'flex'} justifyContent={'end'} height={'100%'}>
          <Button onClick={() => dispatch(setShoeingModal(true))} variant='contained' startIcon={<Add></Add>}>{t('horseShoeing:addHorseShoeing')}</Button>
        </Box>
      }
      <Divider ></Divider>
      <Alert severity='info'>
        {t('profileSectionDescription:horseShoeings')}
      </Alert>
      {(isLoading || isUserLoading) && <LinearProgress></LinearProgress>}
      <I18nDataGrid
        rows={shoeings}
        loading={(isLoading || isUserLoading)}
        columns={columns}
        initialState={{
          pagination: {
            paginationModel: {
              pageSize: 5,
            },
          },
          columns: {
            columnVisibilityModel: {
              id: false
            }
          }
        }}
        slotProps={{
          toolbar: {
            showQuickFilter: true,
          },
        }}
        pageSizeOptions={[5]}
        checkboxSelection={false}
        disableRowSelectionOnClick
        slots={{
          noRowsOverlay: () => <Box display={'flex'} justifyContent={'center'} alignItems={'center'} height={'100%'}>
            <Button onClick={() => dispatch(setShoeingModal(true))} variant='contained' startIcon={<Add></Add>}>{t('horseShoeing:addHorseShoeing')}</Button>
          </Box>
        }}
      />
    </Stack>
  )
}

export default Shoeing